import { render, staticRenderFns } from "./ecology.vue?vue&type=template&id=32cd07ef&scoped=true"
import script from "./ecology.vue?vue&type=script&lang=js"
export * from "./ecology.vue?vue&type=script&lang=js"
import style0 from "./ecology.vue?vue&type=style&index=0&id=32cd07ef&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_bbcd016e015477a3ecf09e87b6c3f580/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32cd07ef",
  null
  
)

export default component.exports